<template lang="pug">
.l-header__inner
  h1.p-headTitle 📛なふだす！
  span.p-subTitle TwitterIDを入力して、一瞬で名札を生成して印刷するツール
</template>

<script>
export default {
  name: 'FooterInner',
    data () {
    return {
       
    } 
  }
}
</script>

<style lang="scss" scoped>
.l-header__inner{
  color: ghostwhite;
}
.p-headTitle{
  margin:0 0 0.5em;
  color: ghostwhite;
}
.p-subTitle{
  color: ghostwhite;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderInner.vue